import { get } from '@/lib/api';

/** 获取路由 */
export const getRouters = (id?: number) => {
  return get('/system/menu/getRouters/info', {}, { headers: id === undefined ? {} : { 'Hospital-Info': id } });
};
